export const portfolioData = {
  personalInfo: {
    name: "Phumlani Khumalo",
    title: "Software Developer",
    location: "Richard's Bay, KZN, South Africa",
    phone: "067 250 5018",
    email: "mntungwa3311@gmail.com",
    linkedin: "https://www.linkedin.com/in/phumlani-khumalo-84601516a",
    github: "https://github.com/MthetheleiiPK",
    driversLicense: "C1"
  },
  
  about: {
    description: "Passionate software developer with expertise in full-stack development, specializing in Flutter, Spring Boot, and cloud technologies. Experienced in building scalable applications and working in Agile environments. Strong problem-solving skills and a track record of delivering efficient solutions.",
    highlights: [
      "Built high-frequency data prediction system reducing processing time by 30%",
      "Experienced in mobile app development with Flutter and React",
      "Proficient in backend development with Spring Boot and Python",
      "Skilled in cloud technologies including AWS and Docker",
      "Strong experience in Agile/SCRUM methodologies"
    ]
  },
  
  skills: {
    languages: ["Java", "Python", "C#", "SQL", "Dart", "JavaScript", "TypeScript", "PHP"],
    frameworks: ["Spring Boot", "Maven", "Flutter", "React", "Node.js", "Django", ".NET Core", "Laravel"],
    ides: ["VS Code", "Visual Studio", "IntelliJ", "NetBeans", "Android Studio"],
    databases: ["SQL Server", "MongoDB", "SQLite", "Oracle", "PostgreSQL"],
    cloudDevops: ["AWS (EC2, S3, RDS)", "Docker", "Git", "Jira", "Postman", "Twilio"],
    networking: ["Protocols", "Active Directory", "SSH", "Sophos"],
    operatingSystems: ["Windows", "Windows Server", "Linux", "AWS Linux", "Android"],
    methodologies: ["Agile/SCRUM", "REST API Design", "Unit Testing"]
  },
  
  experiences: [
    {
      id: 1,
      title: "Flutter Developer Intern",
      company: "Emergexians",
      location: "New Delhi, India (Remote)",
      period: "Jul 2025 – Sep 2025",
      description: "Building a mobile e-hailing app using Flutter, Firebase and Google Maps API.",
      technologies: ["Flutter", "Firebase", "Google Maps API"]
    },
    {
      id: 2,
      title: "Software Developer Intern",
      company: "South African National Space Agency (SANSA)",
      location: "Hermanus (Onsite)",
      period: "Aug 2023 – Jul 2025",
      achievements: [
        "Built a high-frequency data prediction system using Python, reducing processing time by 30%",
        "Engineered a mobile app to control a 360° phone booth, integrating AWS S3 for video storage",
        "Built a mobile asset verification system using Flutter and SQLite",
        "Created a green screen windows application for capturing images/videos with desired background template",
        "Built a digital signature software using Spring Boot as backend and Flutter as frontend"
      ],
      technologies: ["Python", "Flutter", "AWS S3", "SQLite", "Spring Boot", "C#", "Flask"]
    },
    {
      id: 3,
      title: "Junior Back-End Developer",
      company: "Rare Tag",
      location: "Midrand (Remote)",
      period: "Jun 2024 – May 2025",
      achievements: [
        "Contributed to a Spring Boot Restful API (service layers, configurations, dependency injections)",
        "Utilized database views to fetch large chunks of records using a single transaction call",
        "Automated endpoint testing via Postman, reducing debugging time by 25%",
        "Utilized Thymeleaf for generating PDF forms that are populated dynamically",
        "Designed a Flutter-based UI to streamline API testing, enhancing cross-team collaboration",
        "Integrated Swagger for API documentation, improving developer onboarding"
      ],
      technologies: ["Spring Boot", "Postman", "Thymeleaf", "Flutter", "Swagger"]
    },
    {
      id: 4,
      title: "Software Developer (WIL Intern)",
      company: "DUT AppFactory",
      location: "Durban (Onsite)",
      period: "July 2018 – July 2019",
      achievements: [
        "Contributed to an eResearch tracking system using C#, jQuery, and MS SQL Server 2016",
        "Delivered 10+ sprint-based features in an Agile environment, achieving 100% on-time completion"
      ],
      technologies: ["C#", "jQuery", "MS SQL Server", "Agile"]
    }
  ],
  
  projects: [
    {
      id: 1,
      title: "High-Frequency Data Prediction System",
      description: "Built a Python-based system that reduced data processing time by 30% for space agency applications.",
      technologies: ["Python", "Data Analysis", "Performance Optimization"],
      category: "Data Science"
    },
    {
      id: 2,
      title: "Mobile E-Hailing App",
      description: "Developing a comprehensive e-hailing application with real-time tracking and payment integration.",
      technologies: ["Flutter", "Firebase", "Google Maps API"],
      category: "Mobile Development"
    },
    {
      id: 3,
      title: "360° Phone Booth Controller",
      description: "Engineered a mobile application to control a 360° photo booth with AWS S3 integration for video storage.",
      technologies: ["Flutter", "AWS S3", "Mobile Development"],
      category: "Mobile Development"
    },
    {
      id: 4,
      title: "Digital Signature Software",
      description: "Full-stack digital signature solution with Spring Boot backend and Flutter frontend.",
      technologies: ["Spring Boot", "Flutter", "Full-Stack"],
      category: "Web Application"
    },
    {
      id: 5,
      title: "Asset Verification System",
      description: "Mobile application for asset verification and management using Flutter and SQLite.",
      technologies: ["Flutter", "SQLite", "Mobile Development"],
      category: "Mobile Development"
    },
    {
      id: 6,
      title: "Green Screen Application",
      description: "Windows application for capturing images/videos with customizable backgrounds and sharing capabilities.",
      technologies: ["C#", "Flask", "AWS S3", "Windows Forms"],
      category: "Desktop Application"
    }
  ],
  
  education: [
    {
      degree: "B Tech: IT (Software Development)",
      institution: "Durban University of Technology",
      location: "Durban, South Africa",
      period: "Jul 2019 – Sep 2020",
      details: "Advanced software development concepts and practical applications"
    },
    {
      degree: "N Dip: IT (Software Development)",
      institution: "Mangosuthu University of Technology",
      location: "Durban, South Africa",
      period: "Jan 2016 – Dec 2018",
      details: "Foundation in software development principles and practices"
    }
  ],
  
  references: [
    {
      name: "Dr Bethel Mutanga",
      relation: "IT Lecturer/ WIL Coordinator (MUT)",
      contact: "072 265 7439 / mutangamb@mut.ac.za"
    },
    {
      name: "Mr Funanani Nekhunguni",
      relation: "Backend Developer (RareTag)",
      contact: "079 588 9465"
    },
    {
      name: "Ms Nieboheng Molefe",
      relation: "Junior Software Developer (SANSA)",
      contact: "069 569 9360 / nmolefe@sansa.org.za"
    },
    {
      name: "Mr Chaudhary Kumar",
      relation: "Emergexians InfoTech CEO",
      contact: "+91 75488 77535"
    }
  ]
};